import React, { useEffect, useState } from 'react';
import {
  Box,
  makeStyles,
  Typography,
  Card,
  CardMedia,
  CardContent,
  TablePagination,
  CircularProgress,
  Tooltip,
  Badge,
  Avatar,
  Tabs,
  Tab,
  Link,
  Divider,
  Button
} from '@material-ui/core';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Page from '../../../components/Page';
import BannerImg from '../../../assets/banner/banner-image-tgh.png';
import { get, isEmpty, head, map, concat } from 'lodash';
import UserAPI from '../../../api/User';
import LeaderboardEntryAPI from '../../../api/LeaderboardEntry';
import UserProfileSpeedrunTable from './UserProfileSpeedrunTable';
import { ABYSS_VERSION_HISTORY } from '../../../constants';
import UserProfileCharacterDisplay from './UserProfileCharacterDisplay';
import UserProfileFeaturedCharacterDisplay from './UserProfileFeaturedCharacterDisplay';
import UserProfileAbyssRanking from './UserProfileAbyssRanking';
import getSearchQuery from '../../../utils/getSearchQuery';
import CharacterSnapshotModal from '../../../components/CharacterSnapshotModal';
import AccountSnapshotAPI from '../../../api/AccountSnapshot';
import StarIcon from '@mui/icons-material/Star';
import PlaceholderImg from '../../../assets/misc/Placeholder.webp';
import WLImage from '../../../assets/misc/WL_ICON.png';
import clsx from 'clsx';
import { Helmet } from 'react-helmet';
import CompetitorAPI from '../../../api/Competitor';
import AchievementImage from '../../../assets/misc/Achievement.webp';
import YoutubePlayerModal from '../../../components/YoutubePlayerModal';
import CloseIcon from '@mui/icons-material/Close';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import DpsEntryAPI from '../../../api/DpsEntry';
import UserProfileDPSTable from './UserProfileDPSTable';
import numeral from 'numeral';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useHistory } from 'react-router';
import moment from 'moment';
import CustomSnackbar from '../../../components/CustomSnackbar';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { KeqingFlower } from '../../../constants/EasterEggs';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  bannerPageContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: theme.palette.primary.hover,
    flexGrow: 1
  },
  filterSelect: {
    width: '100%',
    flexShrink: 1,
    height: 'fit-content',
    zIndex: 1,
    maxWidth: '15rem'
  },
  cardRow: {
    marginTop: '1rem',
    position: 'relative',
    width: '55%',
    minWidth: '1200px',
    display: 'flex',
    alignItems: 'stretch'
  },
  cardRowEl: {
    borderRadius: 0,
    backgroundColor: theme.palette.secondary.secondary,
    overflow: 'hidden'
  },
  profileCard: {
    marginTop: '1rem',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: 0,
    backgroundColor: theme.palette.secondary.secondary,
    width: '55%',
    minWidth: '1200px'
  },
  pagination: {
    overflow: 'hidden',
    fontSize: '12px'
    // color: 'black'
  },
  importantCardText: {
    // color: 'black',
    fontSize: '16px',
    fontWeight: 'bold'
  },
  profileInfo: {
    color: 'grey',
    textAlign: 'center',
    width: 'fit-content'
  },
  profileSection: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly'
  },
  role: {
    borderRadius: '5px',
    color: 'white',
    backgroundColor: theme.palette.secondary.main,
    padding: '0 0.5rem 0 0.5rem',
    marginLeft: '1rem',
    fontSize: '12px'
  },
  cardText: {
    color: theme.palette.text.primary,
    margin: '1rem'
  },
  btn: {
    paddingLeft: '2rem',
    paddingRight: '2rem',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover
    },
    borderRadius: 5
  },
  textInput: {
    color: `${theme.palette.text.primary} !important`
  },
  boldedCardText: {
    color: theme.palette.text.primary,
    fontWeight: 'bold',
    fontSize: '18px'
  },
  inputGroup: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'center'
  },
  loading: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '50px',
    zIndex: 2
  },
  doneLoading: {
    display: 'none'
  },
  formError: {
    fontFamily: 'Inter',
    fontSize: '12px'
  },
  characterSideBar: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  characterImage: {
    width: '4rem !important',
    height: '4rem !important',
    backgroundColor: theme.palette.text.primary,
    margin: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.text.secondary
    }
  },
  alias: {
    padding: '0.7rem',
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.background.dark,
    color: theme.palette.text.secondary,
    fontWeight: '400'
  },
  rankHistory: {
    display: 'flex',
    marginTop: '2rem',
    width: '55%',
    minWidth: '1200px',
    flexWrap: 'wrap'
  },
  rankHistoryPill: {
    color: theme.palette.text.primary,
    paddingLeft: '0.2rem',
    paddingRight: '0.2rem',
    marginLeft: '0.3rem',
    marginRight: '0.3rem',
    borderRadius: '5px',
    border: '1px solid #ced3d3',
    backgroundColor: theme.palette.primary.secondary,
    boxShadow: '0px 0px 1px 1px #cdd2d2',
    display: 'flex'
  },
  profileIcon: {
    height: '80px',
    width: '80px'
  },
  profileIconContainer: {
    width: '80px',
    height: '80px',
    border: `1px solid ${theme.palette.secondary.main}`,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      height: '80px',
      width: '80px',
      boxShadow: 'inset 0 0 10px black'
    }
  },
  profileLevel: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    paddingLeft: '0.2rem',
    paddingRight: '0.2rem',
    backgroundColor: theme.palette.background.dark,
    color: `${theme.palette.secondary.main} !important`,
    border: `1px solid ${theme.palette.background.dark}`
  },
  signature: {
    backgroundColor: theme.palette.secondary.tabs,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    width: '100%',
    height: '70px',
    overflow: 'auto',
    padding: '0.5rem'
  },
  characterTabs: {
    padding: 0
  },
  selected: {
    border: '1px solid #cdd2d2',
    borderBottom: 'none',
    backgroundColor: theme.palette.secondary.secondary,
    fontWeight: '500',
    textTransform: 'none',
    fontSize: '14px',
    color: theme.palette.text.primary
  },
  notSelected: {
    border: 'none',
    backgroundColor: theme.palette.secondary.tabs,
    borderBottom: '1px solid #cdd2d2',
    fontWeight: '200',
    textTransform: 'none',
    color: theme.palette.text.primary,
    fontSize: '14px'
  },
  characterTab: {
    width: '100%',
    flexGrow: 1,
    backgroundColor: theme.palette.secondary.secondary,
    border: '1px solid #cdd2d2',
    marginTop: '-2px'
  },
  text: {
    fontSize: '12px'
    // color: '#8c96a2'
  },
  videoModal: {
    borderRadius: 0,
    boxShadow: '0px 0px 1px 1px #cdd2d2',
    padding: 0,
    width: '800px',
    height: '700px',
    overflow: 'auto'
  },
  videoModalHeader: {
    color: theme.palette.tertiary.secondary,
    fontWeight: '600',
    width: '100%',
    height: 'fit-content',
    // backgroundColor: 'white',
    border: '1px solid #cdd2d2',
    marginBottom: '1rem'
  },
  youtubePlayer: {
    width: '650px',
    height: '450px',
    boxShadow: 'inset 0 0 10px black',
    borderRadius: 10
  },
  youtubePlayerContainer: {
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    flexGrow: 1
  },
  teamDisplay: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  viewProfileBtn: {
    backgroundColor: '#f2f2f2',
    borderRadius: 10,
    color: `${theme.palette.background.dark} !important`,
    '&:hover': {
      backgroundColor: '#ced3d3'
    },
    marginLeft: '1rem'
  },
  characterImageVideoPreview: {
    backgroundColor: '#ebeef1',
    boxShadow: '0px 0px 1px 1px #cdd2d2',
    border: '1px solid #cdd2d2',
    height: '40px',
    width: '40px',
    margin: '0.1rem'
  },
  refreshIcon: {
    position: 'absolute',
    left: '10px',
    top: '10px',
    backgroundColor: '#eaeaea',
    borderRadius: 0,
    color: `${theme.palette.background.dark} !important`,
    '&:hover': {
      backgroundColor: '#ced3d3'
    }
  },
  countdown: {
    boxShadow: '0px 0px 5px inset black'
  },
  ready: {}
}));

function UserProfileView(props) {
  const classes = useStyles();
  const history = useHistory();

  const [userName, setUserName] = useState(null);
  const [competitorId, setCompetitorId] = useState(null);
  const [profileBanner, setProfileBanner] = useState(null);
  const [profilePicture, setProfilePicture] = useState(null);
  const [speedrunParams, setSpeedrunParams] = useState({
    competitor: competitorId,
    approved: true,
    sortBy: 'created_at',
    sortDir: 'desc',
    limit: 10,
    page: 0
  });
  const [recentSpeedruns, setRecentSpeedruns] = useState([]);
  const [speedrunCount, setSpeedrunCount] = useState(0);
  const [user, setUser] = useState(null);
  const [profileInformation, setProfileInformation] = useState({});
  const [ttl, setTtl] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [characterSnapshots, setCharacterSnapshots] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [videoModalContent, setVideoModalContent] = useState({});
  const [videoOpen, setVideoOpen] = useState(false);
  const [dpsParams, setDpsParams] = useState({
    competitor: competitorId,
    approved: true,
    sortBy: 'created_at',
    sortDir: 'desc',
    limit: 10,
    page: 0
  });
  const [recentDps, setRecentDps] = useState([]);
  const [dpsCount, setDpsCount] = useState(0);
  const [snackbarMsg, setSnackbarMsg] = useState(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState(null);
  const { characterAssets } = useSelector(state => state.gameAssets);

  function TabPanel(props) {
    const { children, value, index, classes, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        className={get(props.classes, 'root')}
        {...other}
      >
        {value === index && <>{children}</>}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`
    };
  }

  function handleTabChange(event, newValue) {
    setTabValue(newValue);
  }

  /**
   * @description Closes the character modal
   */
  function handleClose() {
    setModalContent(null);
    setCharacterSnapshots(null);
    setOpen(false);
  }

  /**
   * @description Handles opening of character modal
   */
  function setModal(data) {
    return () => {
      setModalContent(data);
      setOpen(true);
    };
  }

  /**
   * @description Loads account + character snapshots into state
   * @param {any} accountSnapshotId - id of snapshot to load
   */
  function loadRunDetails(accountSnapshotId) {
    return () => {
      AccountSnapshotAPI.getById(accountSnapshotId).then(response => {
        setCharacterSnapshots(response.characterSnapshots);
        setModalContent(head(response.characterSnapshots));
        setOpen(true);
      });
    };
  }

  useEffect(() => {
    const qp = getSearchQuery(props.location.search);

    if (!qp.name && !qp.alias) return;

    if (qp.name) {
      setUserName(qp.name);

      return;
    }

    if (qp.alias) {
      CompetitorAPI.getByAlias(qp.alias)
        .then(response => {
          setCompetitorId(get(response, 'competitor._id'));
        })
        .catch(console.error);

      return;
    }
  });

  /**
   * @description Gets account information data for display if username is specified
   */
  useEffect(() => {
    if (!userName) return;

    setLoading(true);

    UserAPI.getByName(userName)
      .then(response => {
        setUser(response.user);

        const competitorId = get(response.user, 'competitor._id');

        if (!competitorId) {
          setCompetitorId(null);
          setProfileInformation({});
          setProfileBanner(null);
          setCharacterSnapshots(null);

          setLoading(false);

          return;
        }

        setCompetitorId(competitorId);
        setSpeedrunParams(p => ({ ...p, competitor: competitorId }));
        setDpsParams(p => ({ ...p, competitor: competitorId }));

        UserAPI.getPublicAccountInfo(competitorId, {
          versions: ABYSS_VERSION_HISTORY
        })
          .then(response => {
            UserAPI.getProfileBanner(get(response.user, '_id')).then(
              bannerResponse => {
                setProfileBanner(bannerResponse.filePath);
              }
            );

            UserAPI.getProfilePicture(get(response.user, '_id')).then(
              response => {
                setProfilePicture(response.filePath);
              }
            );

            setProfileInformation(response.userProfileInformation);

            const timeRemaining = moment.duration(
              moment(
                get(
                  response.userProfileInformation,
                  'accountSnapshot.created_at'
                )
              )
                .add(
                  get(response.userProfileInformation, 'accountSnapshot.ttl'),
                  's'
                )
                .diff(moment())
            );

            setTtl(timeRemaining.asSeconds());
          })
          .catch(err => {
            setProfileInformation({});
          })
          .finally(() => setLoading(false));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [userName]);

  /**
   * @description Gets account information data for display if alias is specified
   */
  useEffect(() => {
    if (!competitorId || !!userName) return;

    setLoading(true);
    setSpeedrunParams(p => ({ ...p, competitor: competitorId }));
    setDpsParams(p => ({ ...p, competitor: competitorId }));

    UserAPI.getPublicAccountInfo(competitorId, {
      versions: ABYSS_VERSION_HISTORY
    })
      .then(response => {
        UserAPI.getProfileBanner(get(response.user, '_id')).then(
          bannerResponse => {
            setProfileBanner(bannerResponse.filePath);
          }
        );

        UserAPI.getProfilePicture(get(response.user, '_id')).then(response => {
          setProfilePicture(response.filePath);
        });

        setUser(response.user);
        setProfileInformation(response.userProfileInformation);

        const timeRemaining = moment.duration(
          moment(
            get(response.userProfileInformation, 'accountSnapshot.created_at')
          )
            .add(
              get(response.userProfileInformation, 'accountSnapshot.ttl'),
              's'
            )
            .diff(moment())
        );

        setTtl(timeRemaining.asSeconds());

        setLoading(false);
      })
      .catch(err => {
        setUser(null);
        setProfileInformation({});
        setLoading(false);
      });
  }, [competitorId]);

  /**
   * @description Runs on change of speedrun query parameters
   */
  useEffect(() => {
    if (isEmpty(speedrunParams) || !competitorId) return;

    setLoading(true);
    LeaderboardEntryAPI.getAllSpeedrunEntries(speedrunParams)
      .then(response => {
        setRecentSpeedruns(response.entries.rows);
        setSpeedrunCount(response.entries.count);
        setLoading(false);
      })
      .catch(err => {
        setRecentSpeedruns([]);
        setSpeedrunCount(0);
        setLoading(false);
      });
  }, [speedrunParams]);

  /**
   * @description Handles changing the page number of the table
   * @param {any} event - the Synthetic DOM event
   * @param {number} newPage - new page number
   */
  function handleSpeedrunPageChange(event, newPage) {
    setSpeedrunParams(p => ({
      ...p,
      page: newPage
    }));
  }

  /**
   * @description Handles changing the page size of the table
   * @param {any} event - the Synthetic DOM event
   */
  function handleSpeedrunLimitChange(event) {
    setSpeedrunParams(p => ({
      ...p,
      limit: event.target.value
    }));
  }

  /**
   * @description Runs on change of speedrun query parameters
   */
  useEffect(() => {
    if (isEmpty(dpsParams) || !competitorId) return;

    setLoading(true);
    DpsEntryAPI.getAllDpsEntries(dpsParams)
      .then(response => {
        setRecentDps(response.dpsEntries.rows);
        setDpsCount(response.dpsEntries.count);
        setLoading(false);
      })
      .catch(err => {
        setRecentDps([]);
        setDpsCount(0);
        setLoading(false);
      });
  }, [dpsParams]);

  /**
   * @description Runs timer for refreshing of profile
   */
  useEffect(() => {
    const ttlInterval = setInterval(() => {
      setTtl(current => current - 1);
    }, 1000);

    return () => {
      clearInterval(ttlInterval);
    };
  });

  /**
   * @description Handles changing the page number of the table
   * @param {any} event - the Synthetic DOM event
   * @param {number} newPage - new page number
   */
  function handleDpsPageChange(event, newPage) {
    setDpsParams(p => ({
      ...p,
      page: newPage
    }));
  }

  /**
   * @description Handles changing the page size of the table
   * @param {any} event - the Synthetic DOM event
   */
  function handleDpsLimitChange(event) {
    setDpsParams(p => ({
      ...p,
      limit: event.target.value
    }));
  }

  /**
   * @description Sets video on speedrun video modal, and opens video modal
   */
  function loadSpeedrunVideo(entry, user) {
    if (user) {
      return () => {
        setVideoModalContent({
          url: entry.video_link,
          name: user,
          rank: entry.rank
        });

        setVideoOpen(true);
      };
    }

    return () => {
      setVideoModalContent({
        url: entry.video_link,
        name: get(entry, 'competitor.alias'),
        time: `${!!entry.minutes ? `${entry.minutes}m ` : ''} ${
          entry.seconds
        }s`,
        details: entry.details,
        team_1: get(entry, 'team_1') ?? [],
        team_2: get(entry, 'team_2') ?? []
      });

      setVideoOpen(true);
    };
  }

  /**
   * @description Sets video on dps video modal, and opens video modal
   */
  function loadDpsVideo(entry) {
    return () => {
      setVideoModalContent({
        url: entry.video_link,
        name: get(entry, 'competitor.alias'),
        damage: entry.damage_dealt,
        attackType: entry.attack_type,
        ceiling: entry.character_ceiling,
        team: concat([entry.dps_character], get(entry, 'team', []))
      });

      setVideoOpen(true);
    };
  }

  /**
   * @description Closes the video modal
   */
  function handleCloseVideo() {
    setVideoModalContent({});
    setVideoOpen(false);
  }

  /**
   * @description Generates a new account snapshot
   */
  function refreshProfile() {
    setLoading(true);
    console.log('This feature is under maintainence. Please try again later.');
    // AccountSnapshotAPI.createNewSnapshot({
    //   competitorId: get(account.currentUser, 'competitor._id')
    // })
    //   .then(() => history.go(0))
    //   .catch(err => {
    //     setSnackbarMsg('Error updating profile information.');
    //     setSnackbarSeverity('error');
    //     setLoading(false);
    //   });
  }

  const speedrunTableHeaders = [
    {
      label: 'Category',
      id: 'speedrun_category'
    },
    {
      label: 'Abyss Version',
      id: 'abyss_version'
    },
    {
      label: 'Subcategory',
      id: 'speedrun_subcategory'
    },
    {
      label: 'Watch',
      id: 'video_link'
    },
    {
      label: 'Team',
      id: 'team_1'
    },
    {
      label: 'Team',
      id: 'team_2'
    },
    {
      label: 'Date',
      id: 'created_at'
    },
    {
      label: 'Character Details',
      id: 'account_snapshot'
    }
  ];

  const dpsTableHeaders = [
    {
      label: 'Category',
      id: 'dps_category'
    },
    {
      label: 'Damage Dealt',
      id: 'damage_dealt'
    },
    {
      label: 'Nuker',
      id: 'dps_character'
    },
    {
      label: 'Attack',
      id: 'attack_type'
    },
    {
      label: 'Watch',
      id: 'video_link'
    },
    {
      label: 'Supports',
      id: 'team'
    },
    {
      label: 'Date',
      id: 'created_at'
    },
    {
      label: 'Character Details',
      id: 'account_snapshot'
    }
  ];

  const rankColors = {
    1: '#FFD700',
    2: '#C4D5DB',
    3: '#E3B975'
  };

  return (
    <Page {...props}>
      <Box classes={{ root: classes.bannerPageContainer }}>
        {!isEmpty(videoModalContent) && (
          <YoutubePlayerModal
            open={videoOpen}
            handleClose={handleCloseVideo}
            classes={{ root: classes.videoModal }}
            headerComponent={
              <Box classes={{ root: classes.videoModalHeader }}>
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%',
                    paddingTop: '2rem',
                    paddingLeft: '2rem',
                    paddingRight: '2rem',
                    paddingBottom: '1rem'
                  }}
                >
                  <Typography
                    align="center"
                    style={{ fontWeight: '700', fontSize: '20px' }}
                  >
                    {videoModalContent.name}
                  </Typography>
                  {videoModalContent.time && (
                    <Typography
                      style={{ color: '#8c96a2', marginLeft: '1rem' }}
                    >
                      {videoModalContent.time}
                    </Typography>
                  )}
                  {videoModalContent.rank && (
                    <>
                      <Typography
                        style={{ marginLeft: '1rem' }}
                        classes={{
                          root: clsx({
                            [classes.text]: true,
                            [classes.important]: true,
                            [classes.highTier]: videoModalContent.rank <= 5,
                            [classes.midTier]:
                              5 < videoModalContent.rank &&
                              videoModalContent.rank <= 15,
                            [classes.lowTier]:
                              15 < videoModalContent.rank &&
                              videoModalContent.rank <= 30,
                            [classes.noTier]: 30 < videoModalContent.rank
                          })
                        }}
                      >
                        {videoModalContent.rank}
                      </Typography>
                      <EmojiEventsIcon />
                    </>
                  )}
                  {!!videoModalContent.damage && (
                    <Typography
                      style={{ color: '#8c96a2', marginLeft: '1rem' }}
                    >
                      {numeral(videoModalContent.damage).format('0,0')}
                    </Typography>
                  )}
                  {!!get(
                    videoModalContent.ceiling,
                    videoModalContent.attackType
                  ) && (
                    <Typography
                      style={{ color: '#8c96a2', marginLeft: '1rem' }}
                    >
                      {`(
                      ${numeral(
                        videoModalContent.damage /
                          get(
                            videoModalContent.ceiling,
                            videoModalContent.attackType
                          )
                      ).format('0.00%')}
                    )`}
                    </Typography>
                  )}
                  <CloseIcon
                    onClick={handleCloseVideo}
                    style={{ marginLeft: 'auto', cursor: 'pointer' }}
                  />
                </Box>
                <Divider />
                {(!!get(videoModalContent, 'team_1') ||
                  !!get(videoModalContent, 'team_2')) && (
                  <Box
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      paddingLeft: '2rem',
                      paddingTop: '0.5rem',
                      paddingBottom: '0.5rem'
                    }}
                  >
                    <AvatarGroup
                      className={classes.teamDisplay}
                      spacing="medium"
                    >
                      {map(
                        get(videoModalContent, 'team_1', []),
                        (char, idx) => {
                          return (
                            <Avatar
                              src={get(characterAssets[char], 'avatar')}
                              key={`${idx}-${char}`}
                              className={classes.characterImageVideoPreview}
                            />
                          );
                        }
                      )}
                    </AvatarGroup>
                    <AvatarGroup
                      className={classes.teamDisplay}
                      spacing="medium"
                      style={{ marginLeft: '1.5rem' }}
                    >
                      {map(
                        get(videoModalContent, 'team_2', []),
                        (charData, idx) => {
                          return (
                            <Avatar
                              src={get(
                                characterAssets[charData.name],
                                'avatar'
                              )}
                              key={`${idx}-${charData.name}`}
                              className={classes.characterImageVideoPreview}
                            />
                          );
                        }
                      )}
                    </AvatarGroup>
                  </Box>
                )}
                {(!!get(videoModalContent, 'dps_character') ||
                  !!get(videoModalContent, 'team')) && (
                  <Box
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      paddingLeft: '2rem',
                      paddingTop: '0.5rem',
                      paddingBottom: '0.5rem'
                    }}
                  >
                    <AvatarGroup
                      className={classes.teamDisplay}
                      spacing="medium"
                    >
                      {map(get(videoModalContent, 'team', []), (char, idx) => {
                        return (
                          <Avatar
                            src={get(characterAssets[char], 'avatar')}
                            key={`${idx}-${char}`}
                            className={classes.characterImageVideoPreview}
                          />
                        );
                      })}
                    </AvatarGroup>
                    <AvatarGroup
                      className={classes.teamDisplay}
                      spacing="medium"
                      style={{ marginLeft: '1.5rem' }}
                    >
                      {map(
                        get(videoModalContent, 'team_2', []),
                        (char, idx) => {
                          return (
                            <Avatar
                              src={get(characterAssets[char], 'avatar')}
                              key={`${idx}-${char}`}
                              className={classes.characterImageVideoPreview}
                            />
                          );
                        }
                      )}
                    </AvatarGroup>
                  </Box>
                )}
              </Box>
            }
            footerComponent={
              <Box mt={2}>
                <Link
                  target="_blank"
                  rel="noopener"
                  href={videoModalContent.url}
                  color="inherit"
                  underline="hover"
                >
                  <Typography classes={{ root: classes.text }}>
                    If the video isn't loading, click here
                  </Typography>
                </Link>
              </Box>
            }
            videoLink={videoModalContent.url}
            YoutubePlayerProps={{
              classes: {
                root: classes.youtubePlayer,
                playerContainer: classes.youtubePlayerContainer
              }
            }}
          />
        )}
        {modalContent && (
          <CharacterSnapshotModal
            open={open}
            handleClose={handleClose}
            modalContent={modalContent}
            rightBar={
              <Box classes={{ root: classes.characterSideBar }}>
                {map(characterSnapshots, (charData, idx) => {
                  return (
                    <Tooltip
                      title={`View ${charData.name} Details`}
                      key={charData.name}
                    >
                      <Badge
                        overlap="circle"
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right'
                        }}
                        badgeContent={
                          <Typography
                            style={{ fontWeight: 'bold' }}
                            classes={{ root: classes.text }}
                          >
                            {`C${charData.constellation}`}
                          </Typography>
                        }
                      >
                        <Avatar
                          src={get(characterAssets[charData.name], 'avatar')}
                          key={`${idx}-${charData.name}`}
                          alt={charData.name}
                          className={classes.characterImage}
                          onClick={() => setModalContent(charData)}
                        />
                      </Badge>
                    </Tooltip>
                  );
                })}
              </Box>
            }
          />
        )}
        {get(profileInformation, 'abyssRankings') && (
          <Box classes={{ root: classes.rankHistory }}>
            {map(get(profileInformation, 'abyssRankings'), (ranking, idx) => {
              return (
                <Box key={idx} classes={{ root: classes.rankHistoryPill }}>
                  <Typography
                    style={{ fontWeight: '500' }}
                    classes={{ root: classes.text }}
                  >
                    V.{ranking.version}&nbsp;
                  </Typography>
                  <Typography classes={{ root: classes.text }}>
                    {get(ranking, 'rank.rank')}
                    {get(ranking, 'rank.rank') === 1
                      ? 'st'
                      : get(ranking, 'rank.rank') === 2
                      ? 'nd'
                      : get(ranking, 'rank.rank') === 3
                      ? 'rd'
                      : 'th'}
                  </Typography>
                  {rankColors[get(ranking, 'rank.rank')] && (
                    <StarIcon
                      style={{
                        color: rankColors[get(ranking, 'rank.rank')],
                        height: '17px'
                      }}
                    />
                  )}
                </Box>
              );
            })}
          </Box>
        )}
        <Box
          className={clsx({
            [classes.loading]: isLoading,
            [classes.doneLoading]: !isLoading
          })}
        >
          <CircularProgress color="inherit" />
        </Box>
        {!user && (
          <Card classes={{ root: classes.profileCard }}>
            <CardMedia component="img" image={BannerImg}></CardMedia>
            <CardContent>
              <Box
                style={{ justifyContent: 'flex-start' }}
                classes={{ root: classes.profileSection }}
              >
                <Typography
                  align="center"
                  classes={{ root: clsx(classes.profileInfo, classes.text) }}
                >
                  Either this user does not exist, or has made their profile
                  private.
                </Typography>
              </Box>
            </CardContent>
          </Card>
        )}
        {user && (
          <>
            <Helmet>
              <title>{`${user.name} | The Golden House Player Profile`}</title>
              <meta
                name="description"
                content={`${user.name}'s latest Genshin Impact profile, Spiral Abyss history, and overall statistics.`}
              />
            </Helmet>
            <Card classes={{ root: classes.profileCard }}>
              <CardMedia
                component="img"
                image={profileBanner ?? BannerImg}
                style={{ maxHeight: '400px', backgroundColor: 'grey' }}
                onError={() => setProfileBanner(BannerImg)}
              />
              {competitorId && ttl && (
                <Tooltip title="Refresh latest account and character data from Genshin">
                  <Button
                    classes={{
                      root: clsx({
                        [classes.refreshIcon]: true,
                        [classes.text]: true,
                        [classes.countdown]: ttl > 0,
                        [classes.ready]: !ttl || ttl < 0
                      })
                    }}
                    variant="outlined"
                    startIcon={ttl > 0 ? <AccessTimeIcon /> : <RefreshIcon />}
                    onClick={refreshProfile}
                    disabled={ttl > 0}
                  >
                    {(!ttl || ttl < 0) && 'Update'}
                    {ttl > 0 &&
                      `${Math.floor(ttl / 60)}:${numeral(ttl % 60).format(
                        '00'
                      )}`}
                  </Button>
                </Tooltip>
              )}
              <CardContent style={{ position: 'relative' }}>
                <Box
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Box
                    style={{ justifyContent: 'flex-start' }}
                    classes={{ root: classes.profileSection }}
                  >
                    <Typography
                      align="center"
                      classes={{ root: classes.importantCardText }}
                    >
                      {user.name}
                    </Typography>
                    <Typography
                      align="center"
                      classes={{ root: classes.role }}
                      gutterBottom={false}
                    >
                      {user.role}
                    </Typography>
                    {get(user, 'competitor.speedrunner') && (
                      <Typography
                        align="center"
                        classes={{ root: classes.role }}
                        style={{ backgroundColor: '#62c09e' }}
                        gutterBottom={false}
                      >
                        SPEEDRUNNER
                      </Typography>
                    )}
                    {get(user, 'competitor.dpser') && (
                      <Typography
                        align="center"
                        classes={{ root: classes.role }}
                        style={{ backgroundColor: '#fd9dfb' }}
                        gutterBottom={false}
                      >
                        DPSER
                      </Typography>
                    )}
                  </Box>
                  <KeqingFlower userId={user._id} />
                </Box>
                <Box
                  style={{
                    justifyContent: 'flex-start'
                  }}
                  classes={{ root: classes.profileSection }}
                >
                  <Typography
                    classes={{ root: clsx(classes.profileInfo, classes.text) }}
                  >
                    {`ID: ${user._id}`}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </>
        )}
        {competitorId && (
          <>
            <Box classes={{ root: classes.cardRow }}>
              <Card
                classes={{ root: classes.cardRowEl }}
                style={{ flexShrink: 0 }}
              >
                <CardContent>
                  <Box
                    classes={{ root: classes.profileSection }}
                    style={{
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      flexWrap: 'nowrap'
                    }}
                  >
                    <Box style={{ display: 'flex', flexDirection: 'column' }}>
                      <Box classes={{ root: classes.profileIconContainer }}>
                        <Box
                          classes={{ root: classes.profileIcon }}
                          component="img"
                          alt="Profile Picture"
                          src={profilePicture ?? PlaceholderImg}
                          onError={() => setProfilePicture(PlaceholderImg)}
                        />
                        <Typography
                          classes={{
                            root: clsx(classes.profileLevel, classes.text)
                          }}
                        >
                          {get(
                            profileInformation,
                            'accountSnapshot.level',
                            'N/A'
                          )}
                        </Typography>
                      </Box>
                    </Box>
                    <Box mr={2} />
                    <Box style={{ display: 'flex', flexDirection: 'column' }}>
                      <Box style={{ display: 'flex', flexDirection: 'row' }}>
                        <Box style={{ position: 'relative' }}>
                          <Box
                            component="img"
                            src={WLImage}
                            style={{ height: '80px', width: '80px' }}
                          />
                          <Typography
                            style={{
                              position: 'absolute',
                              left: '50%',
                              top: '80%',
                              transform: 'translate(-50%, -50%)',
                              backgroundColor: '#e0e3e3',
                              color: 'black',
                              paddingLeft: '0.2rem',
                              paddingRight: '0.2rem',
                              borderRadius: '2px',
                              fontWeight: '700',
                              fontSize: '12px',
                              border: '1px solid #ced3d3'
                            }}
                          >
                            {get(
                              profileInformation,
                              'accountSnapshot.world_level',
                              'N/A'
                            )}
                          </Typography>
                        </Box>
                        <Box mr={2} />
                        <Box style={{ position: 'relative' }}>
                          <Box
                            component="img"
                            src={AchievementImage}
                            style={{ height: '80px', width: '80px' }}
                          />
                          <Typography
                            style={{
                              position: 'absolute',
                              left: '50%',
                              top: '80%',
                              transform: 'translate(-50%, -50%)',
                              backgroundColor: '#e0e3e3',
                              color: 'black',
                              paddingLeft: '0.2rem',
                              paddingRight: '0.2rem',
                              fontWeight: '700',
                              fontSize: '12px',
                              border: '1px solid #ced3d3'
                            }}
                          >
                            {get(
                              profileInformation,
                              'accountSnapshot.achievement_count',
                              '0'
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box mt={2} />
                  <Box
                    classes={{ root: classes.profileSection }}
                    style={{
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start'
                    }}
                  >
                    <Box classes={{ root: classes.signature }}>
                      <Typography
                        classes={{
                          root: clsx(classes.textInput, classes.text)
                        }}
                      >
                        {get(
                          profileInformation,
                          'accountSnapshot.signature',
                          ''
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
              <Box
                style={{
                  marginRight: '1rem'
                }}
              />
              <Card
                classes={{ root: classes.cardRowEl }}
                style={{ flexGrow: 1 }}
              >
                <CardContent style={{ padding: 0, height: '100%' }}>
                  <Box
                    classes={{ root: classes.profileSection }}
                    style={{
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      flexDirection: 'column',
                      height: '100%'
                    }}
                  >
                    <Tabs
                      classes={{ root: classes.characterTabs }}
                      onChange={handleTabChange}
                      value={tabValue}
                      TabIndicatorProps={{
                        style: {
                          display: 'none'
                        }
                      }}
                    >
                      <Tab
                        label="Featured"
                        {...a11yProps(0)}
                        classes={{
                          root: clsx({
                            [classes.selected]: tabValue === 0,
                            [classes.notSelected]: tabValue !== 0
                          })
                        }}
                      />
                      <Tab
                        label="Most Used"
                        {...a11yProps(1)}
                        classes={{
                          root: clsx({
                            [classes.selected]: tabValue === 1,
                            [classes.notSelected]: tabValue !== 1
                          })
                        }}
                      />
                    </Tabs>
                    <TabPanel
                      value={tabValue}
                      index={0}
                      classes={{ root: classes.characterTab }}
                    >
                      <UserProfileFeaturedCharacterDisplay
                        classes={{
                          text: classes.profileInfo
                        }}
                        data={get(profileInformation, 'characterSnapshots', [])}
                        setModal={setModal}
                      />
                    </TabPanel>
                    <TabPanel
                      value={tabValue}
                      index={1}
                      classes={{ root: classes.characterTab }}
                    >
                      <UserProfileCharacterDisplay
                        classes={{
                          text: classes.profileInfo
                        }}
                        data={get(profileInformation, 'characterUsage', [])}
                      />
                    </TabPanel>
                  </Box>
                </CardContent>
              </Card>
            </Box>
            <Card classes={{ root: classes.profileCard }}>
              <CardContent>
                <UserProfileAbyssRanking
                  classes={{
                    text: classes.profileInfo
                  }}
                  data={get(profileInformation, 'abyssRankings', [])}
                  loadVideo={loadSpeedrunVideo}
                />
              </CardContent>
            </Card>
            <Card classes={{ root: classes.profileCard }}>
              <CardContent>
                <Box
                  classes={{ root: classes.profileSection }}
                  style={{ justifyContent: 'flex-start' }}
                >
                  <Typography
                    align="center"
                    classes={{ root: clsx(classes.profileInfo, classes.text) }}
                  >
                    Speedrun Submission History:
                  </Typography>
                </Box>
                <UserProfileSpeedrunTable
                  headers={speedrunTableHeaders}
                  rows={recentSpeedruns}
                  sortBy={speedrunParams.sortBy}
                  sortDir={speedrunParams.sortDir}
                  loadSnapshot={loadRunDetails}
                  loadVideo={loadSpeedrunVideo}
                />
                <TablePagination
                  classes={{
                    root: classes.pagination,
                    menuItem: classes.pagination
                  }}
                  component="div"
                  count={speedrunCount}
                  onChangePage={handleSpeedrunPageChange}
                  onChangeRowsPerPage={handleSpeedrunLimitChange}
                  page={speedrunParams.page}
                  rowsPerPage={speedrunParams.limit}
                  rowsPerPageOptions={[10]}
                  labelRowsPerPage="Rows per page:"
                  labelDisplayedRows={({ from, to, count, page }) =>
                    `${from}-${to} of ${count}`
                  }
                />
              </CardContent>
            </Card>
            <Card classes={{ root: classes.profileCard }}>
              <CardContent>
                <Box
                  classes={{ root: classes.profileSection }}
                  style={{ justifyContent: 'flex-start' }}
                >
                  <Typography
                    align="center"
                    classes={{ root: clsx(classes.profileInfo, classes.text) }}
                  >
                    DPS Submission History:
                  </Typography>
                </Box>
                <UserProfileDPSTable
                  headers={dpsTableHeaders}
                  rows={recentDps}
                  sortBy={dpsParams.sortBy}
                  sortDir={dpsParams.sortDir}
                  loadSnapshot={loadRunDetails}
                  loadVideo={loadDpsVideo}
                />
                <TablePagination
                  classes={{
                    root: classes.pagination,
                    menuItem: classes.pagination
                  }}
                  component="div"
                  count={dpsCount}
                  onChangePage={handleDpsPageChange}
                  onChangeRowsPerPage={handleDpsLimitChange}
                  page={dpsParams.page}
                  rowsPerPage={dpsParams.limit}
                  rowsPerPageOptions={[10]}
                  labelRowsPerPage="Rows per page:"
                  labelDisplayedRows={({ from, to, count, page }) =>
                    `${from}-${to} of ${count}`
                  }
                />
              </CardContent>
            </Card>
          </>
        )}
        <Box mt={2} />
      </Box>
      <CustomSnackbar
        message={snackbarMsg ?? ''}
        severity={snackbarSeverity ?? 'info'}
        open={!!snackbarMsg}
        onClose={() => setSnackbarMsg(null)}
      />
    </Page>
  );
}

export default UserProfileView;
